/*
 * @Author: liuzhezhe 3449223724@qq.com
 * @Date: 2022-10-25 15:36:27
 * @LastEditors: liuzhezhe 3449223724@qq.com
 * @LastEditTime: 2022-10-26 16:50:44
 * @FilePath: \gerlun-react-website\src\pages\product-center\era-account\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import styles from './era-account.scss'
import product from '../../../common/images/product/product-9.jpg'

const EraAccount = (props) => {
  return <section className={styles['era-account']}>
    <div className={styles['advanced-contnet']}>
      <div className={styles['product']}>
        <img src={product} alt='product' />
        <div>
          <h3>概而论云记账</h3>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['characters']}>
        <h2>代账版</h2>
        <div>
          <p><span>适用群体</span></p>
          <p>有客户管理要求的</p>
          <p>财税服务机构</p>
        </div>
      </div>
      <div className={styles['advanced-table']}>
        <table border='0' cellSpacing='0' cellPadding='0' align='center' width='100%'>
          <tbody>
            <tr className={styles['table-th']}>
              <th>产品版本</th>
              <th colSpan='3'>主要功能</th>
            </tr>
            <tr>
              <td rowSpan='16' className={styles['advanced-gaoji']}><span>代账版</span></td>
              <td className={styles['advanced-index']}>多用户</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td className={styles['advanced-index']}>组织架构</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td className={styles['advanced-index']}>授权管理</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td rowSpan='3' className={styles['advanced-center']}>客户管理</td>
              <td colSpan='2' className={styles['advanced-left']}>客户管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>合同管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>收费管理</td>
            </tr>
            <tr>
              <td rowSpan='9' className={styles['advanced-center']}>智能财务管理</td>
              <td colSpan='2' className={styles['advanced-left']}>基础账务</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票批量获取、电票采集</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票、对账单智能生成凭证</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>工资管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>存货管理，出入库单、收发存报表</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>期末成本自动结转、电子归档</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>财务报表申报、个税申报</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>小程序代账端、老版端(不含协同)</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>财务报告（年度、月度）</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles['advanced-yd']}>
        <p><span>适用群体</span></p>
        <p>有客户管理要求的</p>
        <p>财税服务机构</p>
      </div>
    </div>
  </section>
}

export default EraAccount
